function limit(number, min = 0, max = 100) {
    return Math.max(min, Math.min(number, max));
}

export { limit };
//# sourceMappingURL=math-utils.js.map
